import {useTranslation} from 'react-i18next';
import './ArrivalConfirmation.scss';

interface ArrivalConfirmationProps {
    onClose?: VoidFunction;
}

export function ArrivalConfirmation({onClose}: ArrivalConfirmationProps) {
    const {t} = useTranslation();
    const texts = t('arrival.booking_result.confirmed', {returnObjects: true}) as string[];

    setTimeout(async () => {
        if (onClose) {
            onClose();
        }
    }, 7500);

    return (
        <div className='arrival-confirmation'>
            <h2 className='arrival-confirmation__heading'>{t('arrival.booking_result.confirmed_heading')}</h2>
            <div className='arrival-confirmation__queue-box'>
                <span className='checkmark'>&#10003;</span>
            </div>

            <div className='arrival-confirmation__text'>
                {texts.map((txt, ix) => (
                    <p key={ix} dangerouslySetInnerHTML={{__html: txt}} />
                ))}
            </div>
        </div>
    );
}
